import styled from "styled-components";
import { Box } from "@mui/material";

export const ImageSelectorWrapper = styled(Box)`
	.image_list_wrapper {
		overflow-y: auto;

		${props => props.theme.breakpoints.up("md")} {
			li:hover {
				transition: all 0.3s linear;
				box-shadow: inset 0 0 2px 1px rgb(119 154 185 / 70%);
				border-radius: 5px;
			}
		}

		li.selected {
			box-shadow: inset 0 0 3px 1px rgb(119 154 185 / 70%);
			border-radius: 5px;
		}
		li {
			padding: 5px;
			box-sizing: border-box;
		}
	}
	.image_view {
		width: 300px;
		height: 300px;
		object-fit: contain;
		cursor: pointer;
		border: 1px dashed;
		border-radius: 10px;
	}
	.border-dashed {
		border: 1px dashed;
		padding: 20px 10px;
		cursor: pointer;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		grid-gap: 20px;
		svg {
			width: 50px;
			height: 50px;
			color: #888888;
		}
	}
`;
